import React from 'react';
import { addQueryParam } from '../../../../utils/url';
import classes from './styles/index.module.scss';
import RouteLink from '../../../../components/RouteLink';

const HeaderGeneralLanguagesItem = ({ icon, name, languageCode, cultureCode }) => {
	let langHref = '';
	langHref = languageCode ? addQueryParam(window.location.href, 'lang', languageCode) : langHref;
	langHref = cultureCode ? addQueryParam(langHref, 'cult', cultureCode) : langHref;

	return (
		<RouteLink
			href={langHref}
			className={classes.loginPageLanguageItem}
			forceUseLink
		>
			<img
				src={icon}
				className={classes.tooltipLanguageItemIcon}
				alt='lang'
			/>
			<span className={classes.tooltipLanguageItemName}>{name}</span>
		</RouteLink>
	);
};

export default HeaderGeneralLanguagesItem;
